import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import "./System.css"
import { TextField, Button, Table, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer, Pagination } from '@mui/material';
import EditUserInformation from '../Popup/Edituserinformation/Edituserinformation';
import UserDelete from '../Popup/UserDelete/UserDelete';
import UserCreate from '../Popup/UserCreate/UserCreate';
// api
import { getPendingUsers,getAllUserInfo, getUserInfo} from '../../api/admin/userlist/user-list'; // 작성한 API 함수 import
import { userUpdateApprovalStatus } from '../../api/admin/adminApi'; // 작성한 API 함수 import




const System = () => {
  const { t } = useTranslation('adminpage');
    const [search, setSearch] = useState('');
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showCreate, setShowCreate] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [pagedUsers, setPagedUsers] = useState([]);

    const [pendingUsers, setPendingUsers] = useState([]);
    const [allusercount, setAllUserCount] = useState(0);// 전체회원 수
    const [approvalcount, setApprovalCount] = useState(0);// 승인대기 수
    const [activeUsercount, setActiveUserCount] = useState(0);// 승인완료 수
    const [inactiveUsercount, setInactiveUserCount] = useState(0);// 승인거절 수

    const [loadingId, setLoadingId] = useState(null);

  const handleApproval = async (userId, status) => {
    try {
      setLoadingId(userId);
      const res = await userUpdateApprovalStatus(userId, status);
      alert(`유저가 ${status === "APPROVED" ? "승인" : "거부"}되었습니다.`);
      console.log("승인/거부 응답:", res.data);

      // 목록 갱신 (API 다시 호출)
      if (pendingUsers) pendingUsers();
    } catch (error) {
      console.error("승인/거부 실패:", error);
      alert("처리에 실패했습니다.");
    } finally {
      setLoadingId(null);
    }
  };


  //승인대기 회원 목록 조회
  useEffect(() => {
    const fetchData = async () => {
      try {
        const users = await getPendingUsers(); // API 호출
        setPendingUsers(users);
  
        // 승인대기 수
        const pending = users.filter(u => u.approvalStatusDescription === "승인대기").length;
        setApprovalCount(pending);
  
  
      } catch (error) {
        console.error("미승인 유저 조회 실패:", error);
      }
    };
  
    fetchData();
  }, []);


  
 // 데이터 로딩
useEffect(() => {
  const fetchData = async () => {
    try {
      const data = await getUserInfo({
        searchKeyword: search,
        page: page - 0, // API는 0부터 시작
        size: 10,
      });

      const users = data.content;

     // 테이블용 가공
      setPagedUsers(
        users.map((u) => ({
          id: u.id,
          name: u.name,
          role:
            u.roleName === "ROLE_ADMIN"
              ? "관리자"
              : u.roleName === "ROLE_SUPERUSER"
              ? "최고관리자"
              : "사용자",
          status: u.approvalStatusDescription, // 승인대기 / 승인완료 / 승인거부
          joinDate: new Date(u.regDt).toLocaleDateString(),
          raw: u, // 수정/삭제 시 원본 데이터 넘겨주기
        }))
      );


      setPageCount(data.totalPages);
      setAllUserCount(data.totalElements); // 전체 회원 수

    
    } catch (error) {
      console.error("유저 리스트 조회 실패:", error);
    }
  };

  fetchData();
}, [search, page]);

useEffect(() => {
  const fetchData = async () => {
    try {
      const data = await getAllUserInfo({
       
      });

      const users = data.content;
      // 상태별 개수 계산
      const activeCount = users.filter(u => u.approvalStatusDescription === "승인완료").length;
      const inactiveCount = users.filter(u => u.approvalStatusDescription === "승인거부").length;

      setActiveUserCount(activeCount);
      setInactiveUserCount(inactiveCount);

    } catch (error) {
      console.error("유저 리스트 조회 실패:", error);
    }
  };

  fetchData();
}, []);
    
  

  return (
    <div className='System_Container'>
        {/* <div className='System_Title'>사용자관리</div> */}
        <div className='System_User_Dash_Container'>
            <div className='System_User_Dash_Box'>
                <div className='System_User_Dash_Img'>
                    <div className='System_User_Dash_Img_Box'>
                    <img src='/Images/All_User_Icon.png' alt="User_Icon" className='User_img'/>
                    </div>
                    <div className='System_User_Dash_Img_Des'>
                    {t("userpage.userdashboard.alluser")}
                    </div>
                </div>
                <div className='System_User_Dash_Data'>
                    <div>{allusercount}명</div>
                </div>
            </div>
            
            <div className='System_User_Dash_Box'>
                <div className='System_User_Dash_Img'>
                    <div className='System_User_Dash_Img_Box'>
                    <img src='/Images/Waiting_User_Icon.png' alt="User_Icon" className='User_img'/>
                    </div>
                    <div className='System_User_Dash_Img_Des'>
                    {t("userpage.userdashboard.approvaluser")}
                    </div>
                </div>
                <div className='System_User_Dash_Data'>
                    <div>{approvalcount} 명</div>
                </div>
            </div> 
            <div className='System_User_Dash_Box'>
                <div className='System_User_Dash_Img'>
                    <div className='System_User_Dash_Img_Box'>
                    <img src='/Images/Active_User_Icon.png' alt="User_Icon" className='User_img'/>
                    </div>
                    <div className='System_User_Dash_Img_Des'>
                    {t("userpage.userdashboard.activeuser")}
                    </div>
                </div>
                <div className='System_User_Dash_Data'>
                    <div>{activeUsercount}명</div>
                </div>
            </div> 
            <div className='System_User_Dash_Box'>
                <div className='System_User_Dash_Img'>
                    <div className='System_User_Dash_Img_Box'>
                    <img src='/Images/Inactive_User_Icon.png' alt="User_Icon" className='User_img'/>
                    </div>
                    <div className='System_User_Dash_Img_Des'>
                    {t("userpage.userdashboard.inactiveuser")}
                    </div>
                </div>
                <div className='System_User_Dash_Data'>
                    <div>{inactiveUsercount}명</div>
                </div>
            </div>

        </div>
        <div className='System_User_Waiting_Container'>
        <div className='System_User_Waiting_Title'>{t("userpage.approvelist.title")}</div>
      <div className='System_User_Waiting_Data_Container'>
        {pendingUsers.length > 0 ? (
          pendingUsers.map((user) => (
            <div className='System_User_Waiting_Box' key={user.id}>
              <div>{user.name}</div>
              <div>{user.userId}</div>
              <div>신청일: {new Date(user.regDt).toLocaleDateString()}</div>
              <div>
                <button
                  className='approval_btn'
                  onClick={() => handleApproval(user.id, "APPROVED")}
                  disabled={loadingId === user.id}
                >
                  {loadingId === user.id ? "처리 중..." : `${t("userpage.approvelist.approved")}`}
                </button>
                <button
                  className='refusal_btn'
                  onClick={() => handleApproval(user.id, "REJECTED")}
                  disabled={loadingId === user.id}
                >
                  {loadingId === user.id ? "처리 중..." : `${t("userpage.approvelist.rejected")}`}
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className='System_User_Waiting_Box_None'>
            승인 대기 사용자가 없습니다.
          </div>
        )}
      </div>
    </div>

    
    <div className="System_User_list_Container">
      {/* 헤더 */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 style={{ color: "#fff" }}>{t("userpage.alluserlist.title")}</h2>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <input
           
            placeholder={t("userpage.alluserlist.search")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className='Sreach_Textfield'
          />
          <button className='create_btn' onClick={() => setShowCreate(true)}>
          + {t("userpage.alluserlist.usercreate")}
          </button>
        </div>
      </div>

      {/* 테이블 */}
      <TableContainer>
        <Table sx={{ tableLayout: "fixed", width: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "20%", color: "white" }}>{t("userpage.alluserlist.user")}</TableCell>
              <TableCell sx={{ width: "15%", color: "white" }}>{t("userpage.alluserlist.권한")}</TableCell>
              <TableCell sx={{ width: "15%", color: "white" }}>{t("userpage.alluserlist.상태")}</TableCell>
              <TableCell sx={{ width: "25%", color: "white" }}>{t("userpage.alluserlist.가입일")}</TableCell>
              <TableCell sx={{ width: "25%", color: "white" }}>{t("userpage.alluserlist.관리")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={{padding:'none'}}>
            {pagedUsers.map((user) => (
              <TableRow key={user.id}>
                <TableCell sx={{ color: "white" }}>{user.name}</TableCell>
                <TableCell sx={{ color: "white" }}>{user.role}</TableCell>
                <TableCell
                  sx={{
                    color: user.status === "승인완료" ? "#49D890" : "#FF5A67",
                    fontWeight: "bold",
                  }}
                >
                  {user.status}
                </TableCell>
                <TableCell sx={{ color: "white" }}>{user.joinDate}</TableCell>
                <TableCell sx={{ color: "white" }}>
                <Button
                    size="small"
                    onClick={() => {
                      setSelectedUser(user.raw); // user.raw에 id 포함
                      setShowEdit(true);          // 모달 열기
                    }}
                  >
                    {t("userpage.alluserlist.edit")}
                  </Button>
                  |
                  <Button
                    size="small"
                    color="error"
                    onClick={() => {
                      setSelectedUser(user.raw);
                      setShowDelete(true);
                    }}
                    sx={{ ml: 1 }}
                  >
                    {t("userpage.alluserlist.delete")}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* 페이지네이션 */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem", color: "white" }}>
        <Pagination
          count={pageCount}
          page={page}
          onChange={(e, value) => setPage(value)}
          color="primary"
        />
      </div>

      {/* 모달 */}
      {showEdit && (
        <div className="PopupContainer">
          <EditUserInformation
            user={selectedUser} // id 포함
            setShowEdit={setShowEdit}
          />
        </div>
      )}
      {showDelete && (
        <div className="PopupContainer">
          <UserDelete user={selectedUser} setShowDelete={setShowDelete} />
        </div>
      )}
      {showCreate && (
        <div className="PopupContainer">
          <UserCreate setShowCreate={setShowCreate} />
        </div>
      )}
    </div>
       
    </div>
  );
};

export default System;